
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34559',
  depVersions: {
  "documents-public-ui": "static-1.34559",
  "atom": "static-1.5085",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2509",
  "client-types": "static-1.466",
  "cssUtils": "static-1.794",
  "customer-data-filters-ui": "static-1.39850",
  "customer-data-objects": "static-1.7682",
  "customer-data-property-utils": "static-1.8103",
  "documents-lib": "static-1.34564",
  "emoji-mart": "static-3.4",
  "flux-actions": "static-1.338",
  "FormsCommonComponents": "static-1.85900",
  "FormUrlGenerator": "static-2.4731",
  "foundations-theming-specialty": "static-1.2148",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.5007",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5604",
  "hs-test-utils": "static-1.8026",
  "hub-http": "static-1.6234",
  "hubspot-dlb": "static-2.1854",
  "HubStyle": "static-2.11791",
  "HubStyleTokens": "static-2.11484",
  "I18n": "static-7.1628",
  "icons": "static-2.648",
  "jasmine-immutable": "static-1.3034",
  "jasmine-runner": "static-1.6477",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7168",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5413",
  "quartz": "static-1.7049",
  "react": "static-7.186",
  "react-dlb": "static-1.79",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16684",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5353",
  "react-virtualized": "static-2.99",
  "reference-resolvers": "static-1.8183",
  "reference-resolvers-lite": "static-1.8107",
  "reporting-data": "static-1.67619",
  "reporting-reports": "static-1.67297",
  "reporting-snowflake": "static-1.56237",
  "reporting-testing-lib": "static-1.9552",
  "reporting-visualizations": "static-1.59695",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8955",
  "sanitize": "static-1.4489",
  "sanitize-text": "static-1.8154",
  "self-service-api": "static-1.10260",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1760",
  "signup-constants": "static-1.18866",
  "signup-ui-url-generator": "static-2.8064",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4774",
  "tinymce": "static-6.5",
  "transmute": "static-2.85",
  "ui-addon-draggable": "static-3.4775",
  "ui-addon-form-validation": "static-1.11002",
  "ui-asset-management-lib": "static-1.11052",
  "ui-images": "static-2.1156",
  "UIComponents": "static-3.8430",
  "usage-tracker": "static-1.7358",
  "usage-tracker-container": "static-1.7348",
  "usage-tracker-core": "static-1.7208",
  "viral-links-lib": "static-1.7078",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9681",
  "foundations-components": "static-1.7964",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.827",
  "quartz-core": "static-1.6268",
  "quick-fetch": "static-1.3925",
  "raven": "static-3.5925",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "rpc-client-utils": "static-1.4665",
  "ui-addon-i18n": "static-1.11161",
  "ui-addon-upgrades": "static-9.18014",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4132",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3407",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3326",
  "quartz-webpack": "static-1.3273",
  "foundations-assets": "static-1.4879",
  "foundations-theming": "static-1.4432",
  "hub-http-shared-msw-handlers": "static-1.9999",
  "hubspotter-http": "static-1.4660",
  "sassPrefix": "static-1.156",
  "events-data-lib": "static-1.234",
  "conversations-skeleton-state": "static-1.7259",
  "crm-message-bus": "static-1.43039",
  "customer-data-filters-ui-msw-helpers": "static-1.22285",
  "customer-data-objects-ui-components": "static-1.13040",
  "customer-data-reference-ui-components": "static-1.13177",
  "customer-data-ui-utilities": "static-1.9839",
  "framework-builder-read-service-client": "static-1.4013",
  "framework-data-schema-quick-fetch": "static-1.6802",
  "framework-data-schema-resolvers": "static-1.6897",
  "inbound-db-meta-service-client": "static-1.3594",
  "inbound-db-properties-service-client": "static-1.3854",
  "multi-account-reference-resolvers": "static-1.992",
  "onboarding-tours": "static-1.16639",
  "reporting-datasets-permissions-lib": "static-1.13732",
  "ui-addon-teams": "static-1.21572",
  "quartz-auth": "static-1.724",
  "ui-business-units-lib": "static-1.9067",
  "usage-tracker-session-replay": "static-1.5044",
  "ai-components-ui-library": "static-1.9021",
  "ContentUtils": "static-1.68414",
  "customer-data-properties": "static-1.51608",
  "forms-ai-lib": "static-1.4340",
  "forms-utils-lib": "static-1.12612",
  "foundations-components-test-utils": "static-1.5447",
  "react-dnd-compat": "static-1.4627",
  "react-tinymce": "static-1.55290",
  "tinymce-config": "static-2.54416",
  "ui-gdpr-components": "static-1.10363",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3417",
  "HeadJS": "static-2.762",
  "framer-motion": "static-1.72",
  "hs-test-utils-bend-plugin": "static-1.3137",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.89",
  "ui-fonts": "static-1.746",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4340",
  "csstype": "static-1.50",
  "quartz-head": "static-1.714",
  "web-vitals": "static-1.6",
  "batch-promise": "static-1.1554",
  "external-options-client-types": "static-1.4167",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.724",
  "frontend-preferences-client": "static-1.7940",
  "graphql": "static-1.82",
  "immer": "static-1.33",
  "persist-promise": "static-1.3711",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.86",
  "growth-payments-core": "static-1.25430",
  "hubspot-apollo-client": "static-1.4892",
  "foundations-components-legacy": "static-1.989",
  "merchandise-lib": "static-1.264",
  "quartz-routing": "static-1.479",
  "hs-story-utils": "static-1.9437",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.239",
  "timezone-utils": "static-2.5257",
  "seat-types-lib": "static-1.47",
  "bend-plugin-foundations-components": "static-1.4233",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1987",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.836",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-test": "static-1.724",
  "quartz-tracking": "static-1.428",
  "bend-plugin-chirp-manifest": "static-1.75",
  "chirp-fetch": "static-1.1900",
  "purchase-motions-components": "static-1.5929",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4088",
  "bender-build-tools": "static-1.3213",
  "bend-plugin-foundations-theming": "static-1.2915",
  "stylex": "static-1.33",
  "hs-resources": "static-1.165",
  "pulse": "static-1.587",
  "restore-request-side-panel-lib": "static-1.920",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3805",
  "crm-pipelines-api-client-types": "static-1.4147",
  "fdsr-migration-layer": "static-1.16",
  "multi-currency-client-types": "static-1.3699",
  "getting-started-shared-tasks": "static-1.18507",
  "growth-data-modal": "static-1.5449",
  "growth-onboarding-confetti": "static-1.3079",
  "growth-onboarding-next-action-utils": "static-1.1970",
  "navigation-components": "static-1.18082",
  "onboarding-tours-client": "static-1.4853",
  "onboarding-tours-utils": "static-1.705",
  "ui-shepherd-react": "static-3.10177",
  "ui-shepherd-tracker": "static-1.7558",
  "ui-universal-auth": "static-1.8993",
  "user-context": "static-1.5118",
  "hubspotter-http-shared-msw-handlers": "static-1.9997",
  "magpie-lib": "static-1.5560",
  "navigation-messaging": "static-1.7409",
  "amplitude-session-replay-browser": "static-1.60",
  "chatspot-core": "static-1.21399",
  "copilot-toolkit": "static-1.11175",
  "cms-field-types": "static-1.4825",
  "content-icons-ui": "static-1.2229",
  "integrations-lib": "static-1.16202",
  "calling-global-api": "static-1.64567",
  "calling-internal-common": "static-1.31315",
  "calling-lifecycle-internal": "static-1.65949",
  "calling-lifecycle-messages": "static-1.58243",
  "commerce-products-lib": "static-1.9628",
  "crm-links": "static-1.6307",
  "customer-data-properties-shared-msw-handlers": "static-1.9326",
  "file-manager-components": "static-1.23668",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4231",
  "meetings-icalendar-utils-lib": "static-1.644",
  "object-builder-ui-client": "static-1.48801",
  "pipeline-validation-client-types": "static-1.3973",
  "property-value-citations": "static-1.2222",
  "smart-property-lib": "static-1.7155",
  "tiered-pricing": "static-1.1251",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9070",
  "final-form": "static-1.70",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19859",
  "tinymce-themes": "static-1.56386",
  "data-token-picker": "static-1.16433",
  "hub-http-contrib": "static-1.3055",
  "interframe": "static-3.4772",
  "tinymce-data": "static-1.40501",
  "tinymce-plugins": "static-1.57530",
  "ui-addon-sales-email": "static-1.5223",
  "onboarding-scopes": "static-1.6474",
  "ui-addon-opt": "static-4.8379",
  "apollo-link-hub-http": "static-2.4664",
  "hubspot-apollo-cache": "static-1.351",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.185",
  "purchase-motions-api": "static-1.5932",
  "trials-service-types": "static-1.3915",
  "bend-plugin-pulse": "static-1.90",
  "directed-graph": "static-1.948",
  "event-emitter": "static-1.960",
  "fast-json-patch": "static-1.63",
  "onboarding-data-sync-lib": "static-1.1978",
  "growth-onboarding-next-action-components": "static-1.1998",
  "user-context-client": "static-1.4625",
  "idb-keyval": "static-1.44",
  "magpie-types": "static-1.5020",
  "nest": "static-1.240",
  "reactive-lib": "static-1.737",
  "simple-logging-lib": "static-1.3063",
  "unified-auth-core-lib": "static-1.789",
  "getting-started-shared-tasks-store": "static-1.17625",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13617",
  "integrations-tracking-lib": "static-1.5613",
  "native-integrations-shared-strings": "static-1.7794",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10378",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.507",
  "calling-error-reporting": "static-1.31322",
  "shared-worker-versioning": "static-1.11049",
  "calling-usage-tracker": "static-1.6554",
  "voice-sms-access-library": "static-1.1029",
  "customer-data-tracking": "static-1.6902",
  "commerce-permissions": "static-1.782",
  "products-iframe-lib": "static-1.7984",
  "products-ui-components-shared-msw-handlers": "static-1.10381",
  "location-customization-utils-lib": "static-1.9312",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4167",
  "video-components-external": "static-1.11328",
  "video-data-lib": "static-1.34986",
  "data-agent-kit": "static-1.215",
  "feedback-loader": "static-1.29320",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10082",
  "fsm": "static-1.3743",
  "policy-lib": "static-1.6790",
  "react-colorpicker": "static-2.10219",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10145",
  "FileManagerLib": "static-1.39308",
  "NamespacedHubStyle": "static-2.9067",
  "FileManagerCore": "static-1.39167",
  "codemirror": "static-5.95",
  "content-assistance-lib": "static-1.7773",
  "layout-dnd-components": "static-1.12472",
  "layout-dnd-utils": "static-1.11447",
  "react-codemirror": "static-1.10639",
  "ui-addon-emoji-picker": "static-1.9900",
  "ui-brand-identity-lib": "static-1.15339",
  "InboxConnectUtils": "static-4.14861",
  "meetings-connect-utils-lib": "static-1.7618",
  "universal-page-editor-lib": "static-1.3025",
  "google-sheets-integration-lib": "static-1.289",
  "microsoft-drive-integration-lib": "static-1.415",
  "slack-ui-library": "static-1.10405",
  "calling-orchestration-schema": "static-1.35806",
  "sales-views-client-types": "static-1.4271",
  "crm-record-cards-service-types": "static-1.3605",
  "content-media-composition-data-lib": "static-1.12372",
  "content-media-compositions": "static-2.16379",
  "media-bridge-lib": "static-1.18952",
  "trellis-story-utils": "static-1.4528",
  "storybook-react": "static-1.33",
  "audio-components": "static-1.5935",
  "FileManagerImages": "static-1.36819",
  "video-components": "static-1.13331",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4549",
  "video-embed": "static-1.35820",
  "diff-match-patch": "static-1.7",
  "ui-addon-video-player": "static-1.8715",
  "ui-coaching-tips": "static-1.28608",
  "ContentData": "static-1.68489",
  "layout-data-lib": "static-1.9772",
  "browser-eslint": "static-2.57",
  "social-insights-client-types": "static-1.22163",
  "outpost": "static-1.4194",
  "growth-onboarding-feedback-components": "static-1.6593",
  "advanced-menus-core": "static-1.15148",
  "advanced-menus-lib": "static-1.12087",
  "ExportDialog": "static-6.10399",
  "ui-memberships-settings-lib": "static-1.34094",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15147",
  "simple-menus-lib": "static-1.16664"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34559",
  "atom": "/atom/static-1.5085",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2509",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.794",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39850",
  "customer-data-objects": "/customer-data-objects/static-1.7682",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8103",
  "documents-lib": "/documents-lib/static-1.34564",
  "emoji-mart": "/emoji-mart/static-3.4",
  "flux-actions": "/flux-actions/static-1.338",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85900",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4731",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2148",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.5007",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5604",
  "hs-test-utils": "/hs-test-utils/static-1.8026",
  "hub-http": "/hub-http/static-1.6234",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyle": "/HubStyle/static-2.11791",
  "HubStyleTokens": "/HubStyleTokens/static-2.11484",
  "I18n": "/I18n/static-7.1628",
  "icons": "/icons/static-2.648",
  "jasmine-immutable": "/jasmine-immutable/static-1.3034",
  "jasmine-runner": "/jasmine-runner/static-1.6477",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7168",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5413",
  "quartz": "/quartz/static-1.7049",
  "react": "/react/static-7.186",
  "react-dlb": "/react-dlb/static-1.79",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16684",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5353",
  "react-virtualized": "/react-virtualized/static-2.99",
  "reference-resolvers": "/reference-resolvers/static-1.8183",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8107",
  "reporting-data": "/reporting-data/static-1.67619",
  "reporting-reports": "/reporting-reports/static-1.67297",
  "reporting-snowflake": "/reporting-snowflake/static-1.56237",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9552",
  "reporting-visualizations": "/reporting-visualizations/static-1.59695",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8955",
  "sanitize": "/sanitize/static-1.4489",
  "sanitize-text": "/sanitize-text/static-1.8154",
  "self-service-api": "/self-service-api/static-1.10260",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1760",
  "signup-constants": "/signup-constants/static-1.18866",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8064",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4774",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.85",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4775",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11002",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11052",
  "ui-images": "/ui-images/static-2.1156",
  "UIComponents": "/UIComponents/static-3.8430",
  "usage-tracker": "/usage-tracker/static-1.7358",
  "usage-tracker-container": "/usage-tracker-container/static-1.7348",
  "usage-tracker-core": "/usage-tracker-core/static-1.7208",
  "viral-links-lib": "/viral-links-lib/static-1.7078",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9681",
  "foundations-components": "/foundations-components/static-1.7964",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.827",
  "quartz-core": "/quartz-core/static-1.6268",
  "quick-fetch": "/quick-fetch/static-1.3925",
  "raven": "/raven/static-3.5925",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "rpc-client-utils": "/rpc-client-utils/static-1.4665",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11161",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18014",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3407",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3326",
  "quartz-webpack": "/quartz-webpack/static-1.3273",
  "foundations-assets": "/foundations-assets/static-1.4879",
  "foundations-theming": "/foundations-theming/static-1.4432",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9999",
  "hubspotter-http": "/hubspotter-http/static-1.4660",
  "sassPrefix": "/sassPrefix/static-1.156",
  "events-data-lib": "/events-data-lib/static-1.234",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7259",
  "crm-message-bus": "/crm-message-bus/static-1.43039",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22285",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13040",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13177",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9839",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4013",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6802",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6897",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3594",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3854",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.992",
  "onboarding-tours": "/onboarding-tours/static-1.16639",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13732",
  "ui-addon-teams": "/ui-addon-teams/static-1.21572",
  "quartz-auth": "/quartz-auth/static-1.724",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9067",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5044",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9021",
  "ContentUtils": "/ContentUtils/static-1.68414",
  "customer-data-properties": "/customer-data-properties/static-1.51608",
  "forms-ai-lib": "/forms-ai-lib/static-1.4340",
  "forms-utils-lib": "/forms-utils-lib/static-1.12612",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5447",
  "react-dnd-compat": "/react-dnd-compat/static-1.4627",
  "react-tinymce": "/react-tinymce/static-1.55290",
  "tinymce-config": "/tinymce-config/static-2.54416",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10363",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3417",
  "HeadJS": "/HeadJS/static-2.762",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3137",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.89",
  "ui-fonts": "/ui-fonts/static-1.746",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4340",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.714",
  "web-vitals": "/web-vitals/static-1.6",
  "batch-promise": "/batch-promise/static-1.1554",
  "external-options-client-types": "/external-options-client-types/static-1.4167",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.724",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7940",
  "graphql": "/graphql/static-1.82",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3711",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.86",
  "growth-payments-core": "/growth-payments-core/static-1.25430",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4892",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.989",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "quartz-routing": "/quartz-routing/static-1.479",
  "hs-story-utils": "/hs-story-utils/static-1.9437",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.239",
  "timezone-utils": "/timezone-utils/static-2.5257",
  "seat-types-lib": "/seat-types-lib/static-1.47",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4233",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1987",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-test": "/quartz-test/static-1.724",
  "quartz-tracking": "/quartz-tracking/static-1.428",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.75",
  "chirp-fetch": "/chirp-fetch/static-1.1900",
  "purchase-motions-components": "/purchase-motions-components/static-1.5929",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4088",
  "bender-build-tools": "/bender-build-tools/static-1.3213",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2915",
  "stylex": "/stylex/static-1.33",
  "hs-resources": "/hs-resources/static-1.165",
  "pulse": "/pulse/static-1.587",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.920",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3805",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4147",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.16",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3699",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18507",
  "growth-data-modal": "/growth-data-modal/static-1.5449",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3079",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1970",
  "navigation-components": "/navigation-components/static-1.18082",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4853",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.705",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10177",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7558",
  "ui-universal-auth": "/ui-universal-auth/static-1.8993",
  "user-context": "/user-context/static-1.5118",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9997",
  "magpie-lib": "/magpie-lib/static-1.5560",
  "navigation-messaging": "/navigation-messaging/static-1.7409",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "chatspot-core": "/chatspot-core/static-1.21399",
  "copilot-toolkit": "/copilot-toolkit/static-1.11175",
  "cms-field-types": "/cms-field-types/static-1.4825",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "integrations-lib": "/integrations-lib/static-1.16202",
  "calling-global-api": "/calling-global-api/static-1.64567",
  "calling-internal-common": "/calling-internal-common/static-1.31315",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65949",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58243",
  "commerce-products-lib": "/commerce-products-lib/static-1.9628",
  "crm-links": "/crm-links/static-1.6307",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9326",
  "file-manager-components": "/file-manager-components/static-1.23668",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4231",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.644",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48801",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3973",
  "property-value-citations": "/property-value-citations/static-1.2222",
  "smart-property-lib": "/smart-property-lib/static-1.7155",
  "tiered-pricing": "/tiered-pricing/static-1.1251",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9070",
  "final-form": "/final-form/static-1.70",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19859",
  "tinymce-themes": "/tinymce-themes/static-1.56386",
  "data-token-picker": "/data-token-picker/static-1.16433",
  "hub-http-contrib": "/hub-http-contrib/static-1.3055",
  "interframe": "/interframe/static-3.4772",
  "tinymce-data": "/tinymce-data/static-1.40501",
  "tinymce-plugins": "/tinymce-plugins/static-1.57530",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5223",
  "onboarding-scopes": "/onboarding-scopes/static-1.6474",
  "ui-addon-opt": "/ui-addon-opt/static-4.8379",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4664",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.351",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.185",
  "purchase-motions-api": "/purchase-motions-api/static-1.5932",
  "trials-service-types": "/trials-service-types/static-1.3915",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.90",
  "directed-graph": "/directed-graph/static-1.948",
  "event-emitter": "/event-emitter/static-1.960",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1978",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1998",
  "user-context-client": "/user-context-client/static-1.4625",
  "idb-keyval": "/idb-keyval/static-1.44",
  "magpie-types": "/magpie-types/static-1.5020",
  "nest": "/nest/static-1.240",
  "reactive-lib": "/reactive-lib/static-1.737",
  "simple-logging-lib": "/simple-logging-lib/static-1.3063",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.789",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17625",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13617",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5613",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7794",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10378",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.507",
  "calling-error-reporting": "/calling-error-reporting/static-1.31322",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11049",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6554",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1029",
  "customer-data-tracking": "/customer-data-tracking/static-1.6902",
  "commerce-permissions": "/commerce-permissions/static-1.782",
  "products-iframe-lib": "/products-iframe-lib/static-1.7984",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10381",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9312",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4167",
  "video-components-external": "/video-components-external/static-1.11328",
  "video-data-lib": "/video-data-lib/static-1.34986",
  "data-agent-kit": "/data-agent-kit/static-1.215",
  "feedback-loader": "/feedback-loader/static-1.29320",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10082",
  "fsm": "/fsm/static-1.3743",
  "policy-lib": "/policy-lib/static-1.6790",
  "react-colorpicker": "/react-colorpicker/static-2.10219",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10145",
  "FileManagerLib": "/FileManagerLib/static-1.39308",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9067",
  "FileManagerCore": "/FileManagerCore/static-1.39167",
  "codemirror": "/codemirror/static-5.95",
  "content-assistance-lib": "/content-assistance-lib/static-1.7773",
  "layout-dnd-components": "/layout-dnd-components/static-1.12472",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11447",
  "react-codemirror": "/react-codemirror/static-1.10639",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9900",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15339",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14861",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7618",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3025",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.289",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.415",
  "slack-ui-library": "/slack-ui-library/static-1.10405",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35806",
  "sales-views-client-types": "/sales-views-client-types/static-1.4271",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3605",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12372",
  "content-media-compositions": "/content-media-compositions/static-2.16379",
  "media-bridge-lib": "/media-bridge-lib/static-1.18952",
  "trellis-story-utils": "/trellis-story-utils/static-1.4528",
  "storybook-react": "/storybook-react/static-1.33",
  "audio-components": "/audio-components/static-1.5935",
  "FileManagerImages": "/FileManagerImages/static-1.36819",
  "video-components": "/video-components/static-1.13331",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4549",
  "video-embed": "/video-embed/static-1.35820",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8715",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28608",
  "ContentData": "/ContentData/static-1.68489",
  "layout-data-lib": "/layout-data-lib/static-1.9772",
  "browser-eslint": "/browser-eslint/static-2.57",
  "social-insights-client-types": "/social-insights-client-types/static-1.22163",
  "outpost": "/outpost/static-1.4194",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6593",
  "advanced-menus-core": "/advanced-menus-core/static-1.15148",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12087",
  "ExportDialog": "/ExportDialog/static-6.10399",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34094",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15147",
  "simple-menus-lib": "/simple-menus-lib/static-1.16664"
}
};
